import { useEffect, useState } from 'react';

import { useMediaQuery } from './use-media-query';

export const useMobile = (width = 768): boolean => {
    const [isMobile, setIsMobile] = useState(false);
    const mq = useMediaQuery(`(max-width: ${width}px)`);

    useEffect(() => {
        setIsMobile(mq);
    }, [mq]);
    return isMobile;
};
